import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { SaveStatus as SaveStatus_1, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { record_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { createElement } from "react";
import * as react from "react";
import { ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { Size, SveaIcon, renderSveaIconBySize } from "../../ViewUtils.js";
import { singleton, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import "../../../src/Containers/LinkAccount/View.scss";


export class LinkAccountProps extends Record {
    constructor(GlobalDependencies) {
        super();
        this.GlobalDependencies = GlobalDependencies;
    }
}

export function LinkAccountProps$reflection() {
    return record_type("Containers.LinkAccount.View.LinkAccountProps", [], LinkAccountProps, () => [["GlobalDependencies", GlobalDependencies$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, children_2;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const header = getTranslation("LinkAccount.Header");
    const body = getTranslation("LinkAccount.Body");
    const children_6 = [(children_4 = [react.createElement("h1", {}, header), createElement("div", {
        dangerouslySetInnerHTML: {
            __html: body,
        },
    }), wrappedButton(new ButtonKind(1), new ButtonProps(defaultProps.Text, (children_2 = [renderSveaIconBySize(new SveaIcon(15), new Size(3)), "BankID (Sverige)"], react.createElement("span", {}, ...children_2)), (_arg) => {
        window.location.href = "/auth/sso";
    }, defaultProps.Disabled, defaultProps.Id, new SaveStatus_1(0), empty(), singleton("login-btn-sso"), defaultProps.Icon))], react.createElement("div", {
        className: "LinkAccount",
    }, ...children_4))];
    return react.createElement("div", {
        className: "container-main container-main--padded",
    }, ...children_6);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\LinkAccount\\View.fs", 50);

